import { useLazyQuery } from "@apollo/client";
import { CURRENT_USER } from "./GetCurrentUser";

export const useGetCurrentUser = () => {
  let currentUserResult = useLazyQuery(CURRENT_USER);
  return currentUserResult;
};
